import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Layout from './components/layout/Layout';
import Hero from './components/sections/Hero';
import Features from './components/sections/Features';
import Testimonials from './components/sections/Testimonials';
import Pricing from './components/sections/Pricing';
import ContactCTA from './components/sections/ContactCTA';
import ScrollToTop from './components/ui/ScrollToTop';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import { AuthProvider } from './context/AuthContext';
import Protected from './components/auth/Protected';
import DashboardRoutes from './components/dashboard/DashboardRoutes';
import ProtectedAdminRoute from './components/admin/ProtectedAdminRoute';
import AdminRoutes from './components/admin/AdminRoutes';
import AdminLogin from './components/admin/pages/AdminLogin';
import { AdminAuthProvider } from './context/AdminAuthContext';
import { ToastProvider } from './components/ui/Toast';

// Create Home component for landing page content
const Home = () => (
  <>
    <Hero />
    <Features />
    <Testimonials />
    <Pricing />
    <ContactCTA />
    <ScrollToTop />
  </>
);

function App() {
  useEffect(() => {
    const handleNavClick = (e) => {
      const href = e.target.getAttribute('href');
      if (href?.startsWith('#')) {
        e.preventDefault();
        const element = document.querySelector(href);
        element?.scrollIntoView({ behavior: 'smooth' });
      }
    };

    const navLinks = document.querySelectorAll('a[href^="#"]');
    navLinks.forEach(link => link.addEventListener('click', handleNavClick));

    return () => {
      navLinks.forEach(link => link.removeEventListener('click', handleNavClick));
    };
  }, []);

  return (
    <ToastProvider>
      <AuthProvider>
        <AdminAuthProvider>
          <AnimatePresence>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Layout><Home /></Layout>} />
              <Route path="/login" element={<Layout><Login /></Layout>} />
              <Route path="/register" element={<Layout><Register /></Layout>} />

              {/* Business Dashboard Routes */}
              <Route 
                path="/dashboard/*" 
                element={
                  <Protected>
                    <DashboardRoutes />
                  </Protected>
                } 
              />

              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route 
                path="/admin/*" 
                element={
                  <ProtectedAdminRoute>
                    <AdminRoutes />
                  </ProtectedAdminRoute>
                } 
              />
            </Routes>
          </AnimatePresence>
        </AdminAuthProvider>
      </AuthProvider>
    </ToastProvider>
  );
}

export default App;